// Разделы в строке крошек на главной (business_apps#1486 §5.9): «Устройства»
// (активна), «Заявки», «Гарантия» — теми же LocationLink, что на страницах
// заявок и гарантии. Только в новом варианте; «Видео» — после шага 6.

import React from 'react'
import styled from 'styled-components'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { ExcludeTurkey } from 'utils/helpers'
import { HOME_VARIANTS, HOME_V2_ENABLED } from '../model/constants'
import { selectHomeVariant } from '../model/selectors'

const Sections = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  margin-left: auto;
  padding-left: 1rem;
  text-transform: capitalize;
`

export default function HomeSectionLinks({ LinkComponent }) {
  const { t } = useTranslation(['devices', 'orders'])
  const location = useLocation()
  const variant = useSelector(selectHomeVariant)

  if (
    !HOME_V2_ENABLED ||
    location.pathname !== '/' ||
    variant !== HOME_VARIANTS.V2
  ) {
    return null
  }

  return (
    <Sections>
      <LinkComponent exact to="/">
        {t('devices:home_v2.sections.devices')}
      </LinkComponent>
      <ExcludeTurkey>
        <LinkComponent to="/orders">
          {t('devices:home_v2.sections.orders')}
        </LinkComponent>
      </ExcludeTurkey>
      <LinkComponent to="/warranty">
        {t('devices:actions.warranty')}
      </LinkComponent>
    </Sections>
  )
}
